import BurgerInHandIcon from 'components/svgs/burger-in-hand';

export const LoggedOutEmptyStateImage = BurgerInHandIcon;
